var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCp2StickerFiguredIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b,.f{fill:#3c3c46;opacity:0.15;}.b,.c,.d,.e,.f,.g{fill-rule:evenodd;}.c{fill:#3ca4ef;}.c,.d,.e,.f,.g{stroke:#3c3c46;stroke-linejoin:round;stroke-width:2px;}.c,.d{stroke-linecap:round;}.d{fill:#89d9fb;}.e{fill:#ffefe0;}.g{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CP-sticker-figured-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 140,
    height: 140
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M98.3,65.56,92.76,71.1C83.13,61.47,66.44,68.24,66.44,82s16.69,20.53,26.32,10.9l17.38,17.38a40,40,0,1,1,0-56.57Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M88.3,59.56,82.76,65.1C73.13,55.47,56.44,62.24,56.44,76S73.13,96.53,82.76,86.9l17.38,17.38a40,40,0,1,1,0-56.57Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M90.3,53.56,84.76,59.1C75.13,49.47,58.44,56.24,58.44,70S75.13,90.53,84.76,80.9l17.38,17.38a40,40,0,1,1,0-56.57Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M86.3,47.56,80.76,53.1C71.13,43.47,54.44,50.24,54.44,64S71.13,84.53,80.76,74.9L98.14,92.28a40,40,0,1,1,0-56.57Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M88.3,41.55,82.76,47.1a15.42,15.42,0,1,0,0,21.8l17.38,17.38A40,40,0,1,1,65.29,18.54Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M71.86,18a39.87,39.87,0,0,1,28.28,11.72L88.39,41.47l-.08.08-23-23h0A40.28,40.28,0,0,1,71.86,18Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M64.75,38.37c0,11,4.48,18.53,11.72,21.69L88.22,41.69l.08-.13-23-10.06v.05A46,46,0,0,0,64.75,38.37Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M64.75,25.11A39.87,39.87,0,0,0,76.46,53.39L88.22,41.64l.08-.08-23-23v0A40.25,40.25,0,0,0,64.75,25.11Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCp2StickerFiguredIcon);
export default __webpack_public_path__ + "static/media/CP2-sticker-figured-icon.228e116c946e39fe1a7857d0e629c87d.svg";
export { ForwardRef as ReactComponent };